import React from "react";
import { Box, Typography, SxProps, Theme } from "@mui/material";
import { btn_value } from "../dashboard/data";

interface RepsSelectButtonProps {
  selectedButtons: string | null;
  handleButtonClick: (item: string) => void;
}

const RepsSelectButton: React.FC<RepsSelectButtonProps> = ({
  selectedButtons,
  handleButtonClick,
}) => {
  return (
    <Box sx={{ display: "flex", overflowX: "scroll", my: 2 }}>
      {btn_value?.map((item, index) => (
        <Box
          key={index}
          sx={{
            
            backgroundColor: selectedButtons === item ? "#459173" : "#E2F1EB",
            color: selectedButtons === item ? "white" : "#637D92",
            padding: "8px 12px", // Add some padding for better button appearance
            borderRadius: "4px", // Add border radius for button-like appearance
            marginRight: "8px", // Add spacing between buttons
            cursor: "pointer", //add cursor pointer for interactivity
          }}
          onClick={() => handleButtonClick(item)}
        >
          <Typography
            variant="caption"
            sx={{ whiteSpace: "nowrap", lineHeight: "10px" }}
          >
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default RepsSelectButton;
